export default __webpack_public_path__ + "static/hero-video-dd93db53fba7879eca8dfd5e1ccb4150.mp4";